module.exports = __webpack_public_path__ + "static/img/5.dafea7d8.jpg";